var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmilingFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3232221E-2E73-4AC1-ABD9-D9507B196DC3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mob-app-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.2-Home-feed_storyline_start-to-charge_main-version",
    transform: "translate(-24.000000, -120.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Segmented-Controller---4-Segments-Copy",
    transform: "translate(0.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smiling-face",
    transform: "translate(24.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#FFDD67",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face",
    transform: "translate(5.348571, 7.452589)",
    fill: "#B26D3C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.65142857,11.7570107 C3.69234508,11.7573713 1.05855863,9.88128716 0.0918857143,7.08455357 C-0.0169318409,6.80387014 0.0362340357,6.48616788 0.230451857,6.25617831 C0.424692037,6.02618874 0.729020397,5.92062735 1.02395609,5.98093809 C1.31889179,6.04124883 1.55735133,6.25780369 1.64571429,6.54558214 C2.3796125,8.68386178 4.39071046,10.1198687 6.65142857,10.1198687 C8.91214669,10.1198687 10.9232446,8.68386178 11.6571429,6.54558214 C11.7455058,6.25780369 11.9839653,6.04124883 12.278901,5.98093809 C12.5738367,5.92062735 12.8781651,6.02618874 13.0724053,6.25617831 C13.2666231,6.48616788 13.319789,6.80387014 13.2109714,7.08455357 C12.2442985,9.88128716 9.61051207,11.7573713 6.65142857,11.7570107 L6.65142857,11.7570107 Z",
    id: "Mouth"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.6285714,
    cy: 1.62215357,
    r: 1.57714286
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.67428571,
    cy: 1.62215357,
    r: 1.57714286
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilingFace);
export default __webpack_public_path__ + "static/media/smiling-face.01b2211f2d6644e1c4eb66059a9bd0af.svg";
export { ForwardRef as ReactComponent };